export const toggleHamburger = (
  hamburgerButtonClassName,
  spMenuClassName,
  breakPoint
) => {
  const trigger = document.querySelector(`.${hamburgerButtonClassName}`);
  const menu = document.querySelector(`.${spMenuClassName}`);
  const links = document.querySelectorAll(`.${spMenuClassName} a`);

  if (!trigger || !menu) {
    return;
  }

  const pointHeader = window.matchMedia(
    `screen and (min-width: ${breakPoint}px)`
  );

  // ハンバーガーボタンのクリックイベント
  trigger.addEventListener("click", (e) => {
    const isExpanded = e.currentTarget.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMenu();
      trigger.focus();
    } else {
      openMenu();
    }
  });

  const openMenu = () => {
    trigger.setAttribute("aria-expanded", "true");
    trigger.setAttribute("aria-label", "メニューを閉じる");
    menu.inert = false;
  };

  const closeMenu = () => {
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-label", "メニューを開く");
    menu.inert = true;
  };

  // メニュー内のリンクをクリックしたら閉じる
  for (const link of links) {
    link.addEventListener("click", () => {
      closeMenu();
      trigger.focus();
    });
  }

  // Escapeキーでメニューを閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && trigger.getAttribute("aria-expanded") === "true") {
      closeMenu();
      trigger.focus();
    }
  });

  // ブレイクポイントをまたいだときにメニューを閉じる
  pointHeader.addEventListener("change", () => {
    if (pointHeader.matches) {
      closeMenu();
    }
  });

  // 初回ロード時にメニューを閉じる
  closeMenu();
};
